export default __webpack_public_path__ + "static/media/Beehaz_01_main.a0f42dd2.png";